var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99984 10.6666C4.89527 10.6666 3.99984 11.5621 3.99984 12.6666C3.99984 13.0348 4.29831 13.3333 4.6665 13.3333H11.3332C11.7014 13.3333 11.9998 13.0348 11.9998 12.6666C11.9998 11.5621 11.1044 10.6666 9.99984 10.6666H5.99984ZM2.6665 12.6666C2.6665 10.8257 4.15889 9.33331 5.99984 9.33331H9.99984C11.8408 9.33331 13.3332 10.8257 13.3332 12.6666C13.3332 13.7712 12.4377 14.6666 11.3332 14.6666H4.6665C3.56193 14.6666 2.6665 13.7712 2.6665 12.6666Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.66665C6.89527 2.66665 5.99984 3.56208 5.99984 4.66665C5.99984 5.77122 6.89527 6.66665 7.99984 6.66665C9.10441 6.66665 9.99984 5.77122 9.99984 4.66665C9.99984 3.56208 9.10441 2.66665 7.99984 2.66665ZM4.6665 4.66665C4.6665 2.8257 6.15889 1.33331 7.99984 1.33331C9.84079 1.33331 11.3332 2.8257 11.3332 4.66665C11.3332 6.5076 9.84079 7.99998 7.99984 7.99998C6.15889 7.99998 4.6665 6.5076 4.6665 4.66665Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.86afc4a6fa91ae3a385747b7210760da.svg";
export { ForwardRef as ReactComponent };